import NavBar from "../../components/Navigation/NavBar";
import Footer from "../../components/Footer/Footer";
import PhoneMockUpPng from '../../assests/Phone mockup.png'
import DownloadImg from '../../assests/scene-3.svg'
import GooglePlay from '../../assests/GooglePlay.png'
import AppleButton from '../../assests/AppleButton.svg'
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import CardCarousel from '../../components/CardCarousel'
import ServiceCard from '../../components/ServiceCard'
import SGCardCarousel from '../../components/SGLoop/SGCardCarousel'
import { useState, useEffect, use, useRef } from "react";
import EventCalendar from "../../components/SGLoop/EventCalendar";
import { getRandomApprovedRentalsWithUser } from "../../services/firestore/rentalService";
import { getRandomApprovedSellWithUser } from "../../services/firestore/sellService";
import { getRandomApprovedTicketingWithUser } from "../../services/firestore/ticketingService";
import { getNextloopServices, getRandomApprovedServicesWithUser } from "../../services/firestore/servicesService";
import SGLoopCard from "../../components/SGLoop/SGLoopCard";
import { getTop10Groups } from "../../services/firestore/SGloopService";
import CommunitySectionTop10 from "../../components/SGLoop/CommunitySectionTop10";
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import navLogo from '../../assests/navLogo.png'
import { Helmet } from "react-helmet";
import FirstSection from "../../components/Home/FirstSection";
import PartnersOrbit from "../../components/Parnters/PartnersOrbit";
import SecondSection from "../../components/Home/SecondSection";
import ThirdSection from "../../components/Home/ThirdSection";

const stats = [
    { id: 1, name: 'Average satisfaction rating received in the past year.', value: '98%' },
    { id: 2, name: 'Our support team is a quick chat or email away.', value: '24/7' },
    { id: 3, name: 'Community Groups and Sub-Community Groups', value: '100+' },
]
const pageVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, transition: { duration: 0.3 } },
};

function HomePageCopy() {

    const [rentalCards, setRentalCards] = useState([]);
    const [sellCards, setSellCards] = useState([]);
    const [servicesCard, setServicesCards] = useState([]);
    const [nextloopServiceCard, setNextloopServiceCards] = useState([]);
    const [ticketingCards, setTicketingCards] = useState([]);
    const [top10Groups, setTop10Groups] = useState([]);

    useEffect(() => {
        const fetchRentals = async () => {
            try {
                const rentals = await getRandomApprovedRentalsWithUser();
                setRentalCards(rentals);
            } catch (error) {
                console.error("Error fetching rentals:", error);
            }
        };

        const fetchSells = async () => {
            try {
                const sells = await getRandomApprovedSellWithUser();
                setSellCards(sells);
            } catch (error) {
                console.error("Error fetching rentals:", error);
            }
        };

        const fetchTicketing = async () => {
            try {
                const ticketing = await getRandomApprovedTicketingWithUser();
                setTicketingCards(ticketing);
            } catch (error) {
                console.error("Error fetching rentals:", error);
            }
        };

        const fetchServices = async () => {
            try {
                const services = await getRandomApprovedServicesWithUser();
                setServicesCards(services);
            } catch (error) {
                console.error("Error fetching rentals:", error);
            }
        };

        const fetchNLServices = async () => {
            try {
                const services = await getNextloopServices();
                setNextloopServiceCards(services);
            } catch (error) {
                console.error("Error fetching rentals:", error);
            }
        };

        const fetchTop10Groups = async () => {
            try {
                const groups = await getTop10Groups();
                setTop10Groups(groups);
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        }
        fetchRentals();
        fetchSells();
        fetchTicketing();
        fetchServices();
        fetchNLServices();
        fetchTop10Groups();
    }, []);

    const secondSectionRef = useRef(null);
    const thirdSectionRef = useRef(null);
  const [activeTab, setActiveTab] = useState("nextloop");

  const goToSecondSection = (tab) => {
    setActiveTab(tab);

    secondSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

   const goToThirdSection = () => {

    thirdSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

    return (
        <>
            <FloatingWhatsApp
                phoneNumber="6591599414"  // your admin number
                accountName="Nextloop Admin"
                allowEsc
                notification
                avatar={navLogo}
                statusMessage="Typically replies within a day"
                chatMessage="Hi! What would you like to know or ask about us?"
            />

            <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
            >
                <div className="mt-20">
                    <NavBar></NavBar>
                    <FirstSection onNodeClick={goToSecondSection} onThirdSectionClick={goToThirdSection}></FirstSection>
                    <div ref={secondSectionRef} className="scroll-mt-24">
                    <SecondSection activeTab={activeTab} setActiveTab={setActiveTab}/>
                    </div>
                    <div ref={thirdSectionRef} className="scroll-mt-24">
                    <ThirdSection/>
                    </div>
                    <PartnersOrbit/>
                    {/* //Footer */}
                    <Footer></Footer>

                </div>
            </motion.div>
        </>
    )
}
export default HomePageCopy;